import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import Button from '@mui/material/Button';
import { useStyles } from './style';

/**
 * @name ActionModalFooter - Action modalCTA component
 * @param {Array} props - CTA data from Eir Action Modal
 * @returns {JSX.Element} - CTA's component
 */
const ActionModalFooter = props => {
  const theme = useTheme();
  const style = useStyles(theme);
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  /**
   * @param {object} stylesMap - Returns style object
   */
  const stylesMap = {
    text: style.text,
    outlined: style.outlined,
    contained: style.contained,
  };
  return (
    <>
      {!sm && !props.load && props?.disclaimer && (
        <Box sx={style.disclaimer}>
          <Typography
            variant='inputLabel'
            sx={style.disclaimerText}
            dangerouslySetInnerHTML={{ __html: props?.disclaimer }}
          />
        </Box>
      )}
      {!props.load && (
        <Box sx={style.ctaContainer}>
          {props?.cta && props?.cta?.length > 0 && (
            <Stack direction='column' spacing={{ xs: 2, sm: 2, md: 2 }} justifyContent={'center'}>
              {props?.cta?.map((item, index) => (
                <Button
                  key={index}
                  onClick={() => props.handleAction(item?.action, item?.url)}
                  type={item?.type}
                  aria-label={item?.ariaLabel}
                  disabled={item?.type === 'contained' && props?.disablecta}
                  variant='buttonMedium'
                  sx={{ ...style.cta, ...(stylesMap[item.type] ?? style.contained) }}
                >
                  {item.name}
                </Button>
              ))}
            </Stack>
          )}
        </Box>
      )}
      {sm && !props.load && props?.disclaimer && (
        <Box sx={style.disclaimer}>
          <Typography
            variant='inputLabel'
            sx={style.disclaimerText}
            dangerouslySetInnerHTML={{ __html: props?.disclaimer }}
          />
        </Box>
      )}
      {props.load && (
        <Stack sx={{ width: '100%' }}>
          <Skeleton height={100} width='30%' sx={{ m: '0 auto' }} />
          <Skeleton height={100} width='30%' sx={{ m: '0 auto' }} />
        </Stack>
      )}
    </>
  );
};

ActionModalFooter.displayName = 'ActionModalFooter';
export default ActionModalFooter;
